// extracted by mini-css-extract-plugin
export default {"ResultCardWrapper":"pkxXaLUC","ResultCardContainer":"i_mAWs0B","Carat":"Y2SrqBtw","Price":"AbyxN7bZ","PriceUnavailable":"VhzcLY_A","PriceContainer":"qP0j421l"};